import * as API_URL from "../../constants/api";
import * as apiService from "../api";
import { getToken } from "../../helpers/common";



const getSuppressionEmailList = async (payload) => {
    try {
        const token = getToken();
        let result = await apiService.post(API_URL.SUPPRESSION_LIST + "/fetch", payload, token);
        return result;
    } catch (e) {
        return { status: false, data: {}, message: e.message };
    }
};

const deleteSuppressionEmailById = async (payload) => {
    try {
        const { id, email } = payload;
        const token = getToken();
        let result = await apiService.deleteData(API_URL.SUPPRESSION_LIST + `/delete/${email}/${id}`, token);
        return result;
    } catch (e) {
        return { status: false, data: {}, message: e.message };
    }
}

const removeSuppressionEmailsInBulk = async (payload) => {
    try {
        const token = getToken();
        let result = await apiService.deleteData(API_URL.SUPPRESSION_LIST + `/deleteInBulk`, token, payload);
        return result;
    } catch (e) {
        return { status: false, data: {}, message: e.message };
    }
}

const removeSuppressionEmailsInBulkByFilter = async (payload) => {
    try {
        const token = getToken();
        let result = await apiService.deleteData(API_URL.SUPPRESSION_LIST + `/deleteInBulkByFilter`, token, payload);
        return result;
    } catch (e) {
        return { status: false, data: {}, message: e.message };
    }
}

const fetchBulkSuppressionDeleteReports = async (payload) => {
    try {
        const token = getToken();
        let result = await apiService.post(API_URL.SUPPRESSION_LIST + `/fetchBulkSuppressionDeleteReport`, payload, token);
        return result;
    } catch (e) {
        return { status: false, data: {}, message: e.message };
    }
}

export { getSuppressionEmailList, deleteSuppressionEmailById, removeSuppressionEmailsInBulk, removeSuppressionEmailsInBulkByFilter, fetchBulkSuppressionDeleteReports };